export default __webpack_public_path__ + "img/157424eff3a486aca55277cd53161b55.svg";